import { createSelector } from 'reselect';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { showSelector } from 'selectors/testTarget/offers/showPDPPercentRecommended/show/showSelector';

const showPDPPercentRecommendedSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => {
    const globalKillswitch = !!Sephora?.configurationSettings?.pdpPercentRecommended?.isEnabled;

    return globalKillswitch && testReady && show;
});

export { showPDPPercentRecommendedSelector };
